import { getContext } from '@fiverr-private/fiverr_context';
import { ALLOCATIONS, EXPERIMENTS, ROLLOUTS } from '@fiverr-private/listing_experiments';
import { useAppContext } from '../context/listingsContext';

export const useShouldShowAggregatedRating = (): boolean => {
    const context = useAppContext();
    const { rollouts = {} } = context;
    const { abTests } = getContext();

    const isInAggregatedRatingRollout = rollouts[ROLLOUTS.MEERKATS_LISTINGS_AGGREGATE_RATING] || false;
    if (!isInAggregatedRatingRollout) {
        return false;
    }

    const experimentGroup = abTests[EXPERIMENTS.MEERKATS_LISTINGS_AGGREGATE_RATING] ?? 0;

    return !!experimentGroup && Number(experimentGroup) > Number(ALLOCATIONS.CONTROL);
};
